<template>
	<div >
		
		<div class="ft20 cl-black cl-main ftw500">多人拼团</div>
		
		<div class="mt20">
			<a-layout>
				<a-layout-header class="layout-classes-header">
					<a-menu class="classes-menu" :defaultSelectedKeys="[selectCurrent]" @click="selectMenu" mode="horizontal">
						<a-menu-item key="goods">拼团商品</a-menu-item>
						<a-menu-item key="manage">拼团管理</a-menu-item>
					</a-menu>
				</a-layout-header>
				<a-layout-content class="layout-classes-content">
					<div v-if="selectCurrent == 'goods'">
						<pin-tuan-goods></pin-tuan-goods>
					</div>
					<div v-if="selectCurrent == 'manage'">
						<pin-tuan-manage></pin-tuan-manage>
					</div>
				</a-layout-content>
			</a-layout>
		</div>
	</div>
				
</template>

<script>
	import pinTuanGoods from './components/PinTuan/goods.vue';
	import pinTuanManage from './components/PinTuan/manage.vue';
	export default {
		components:{
			pinTuanGoods,
			pinTuanManage
		},
		data() {
			return {
				selectCurrent: 'goods',
			}
		},
		methods: {
			selectMenu(e) {
				this.selectCurrent = e.key;
			},
		}
	}
</script>

<style>
	
	.layout-classes-header {
		background: #FFFFFF;
	}
	
	.layout-classes-header {
		padding: 0 20px;
		height: 58px;
		line-height: 57px;
		border-bottom: 1px solid #F0F3F5;
		width: 100%;
	}
	
	.layout-classes-content {
		padding: 0px 0px 10px 0px;
		background: #FFFFFF;
		width: 100%;
		min-height: 800px;
	}
	
	.classes-menu {
		border-bottom: none;
		line-height: 55px;
		font-size: 14px;
	}
</style>
